import { Box, rem, ShadowBox } from 'affiny-ui/src';
import React, { SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export interface IDropDownMenu {
  items: {
    to: string;
    label: string;
    onClick?: (event: SyntheticEvent) => void;
    underlined?: boolean;
    location?: string;
  }[];
  arrowPosition?: 'left' | 'center';
  onClickCallBack?: () => void;
}

export const DropDownMenu = ({
  items,
  arrowPosition = 'left',
  onClickCallBack,
}: IDropDownMenu) => {
  const handleItemClick = (
    e: SyntheticEvent,
    onClick?: (event: SyntheticEvent) => void
  ) => {
    if (onClick) onClick(e);

    if (onClickCallBack) onClickCallBack();
  };

  return (
    <ShadowBox width={rem(256)} px="medium">
      <Box
        position="absolute"
        zIndex={1}
        top={rem(-8)}
        right={arrowPosition === 'center' ? rem(121) : rem(25)}
        width={0}
        height={0}
        borderStyle="solid"
        borderColor="transparent_white"
        borderWidth={rem(8)}
        borderTopWidth={0}
        borderBottomColor="light"
      />

      {items.map(({ to, label, location, onClick, underlined }, index) => (
        <SLink
          key={`item${index}`}
          to={to}
          onClick={e => handleItemClick(e, onClick)}
          style={{
            isLast: index === items.length - 1,
            underlined: underlined,
          }}
          data-test={`drop-down-menu-link-${location}`}
        >
          {label}
        </SLink>
      ))}
    </ShadowBox>
  );
};

interface SlinkProps {
  style?: {
    isLast?: boolean;
    underlined?: boolean;
  };
}

const SLink = styled(Link)<SlinkProps>`
  position: relative;
  text-decoration: ${({ style }) => (style?.underlined ? 'underline' : 'none')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: ${({ style }) =>
    style?.isLast ? 'none' : '1px solid #EAEAEA'};
  min-height: ${rem(60)};
  font-size: ${({ theme }) => theme.fontSizes.size16};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.secondary};
  pointer-events: auto;
  transition: color 300ms ease;
  text-align: center;

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }
`;
